import { responsive, useTheme } from '@wci-tech/core-ui';
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { getContainerStyles } from '@/utils';

export const useStyles = () => {
  const { theme } = useTheme();

  return useMemo(
    () => ({
      wrapper: css`
        width: 100%;
        overflow: hidden;
      `,
      contentWrapper: css`
        ${getContainerStyles(theme)};
        ${responsive.create({
          paddingTop: {
            default: theme.spacing.get(32),
            md: theme.spacing.get(92),
            lg: theme.spacing.get(212),
          },
          paddingBottom: {
            default: theme.spacing.get(48),
            md: theme.spacing.get(92),
            lg: theme.spacing.get(212),
          },
        })}
      `,
      title: css`
        font-weight: ${theme.fonts.weight.medium};
        color: ${theme.colors.commonColors.white};
        text-align: center;
        color: var(--text-color);
        ${responsive.create({
          fontSize: {
            default: `20px`,
            md: `30px`,
            lg: `${theme.fonts.size['4xl']}`,
          },
          maxWidth: {
            default: '320px',
            md: '600px',
            lg: '1200px',
          },
        })}
      `,
      description: css`
        color: ${theme.colors.commonColors.white};
        text-align: center;
        color: var(--desc-text-color);

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.sm}`,
            md: `${theme.fonts.size.md}`,
            lg: `${theme.fonts.size.xl}`,
          },
          maxWidth: {
            md: '600px',
            lg: '895px',
          },
        })}
      `,

      headerSection: css`
        ${responsive.create({
          marginBottom: {
            default: theme.spacing.get(40),
            md: theme.spacing.get(48),
          },
        })}
      `,

      visionSection: css`
        ${responsive.create({
          maxWidth: {
            default: `288px`,
            md: `368px`,
            lg: `518px`,
          },
        })}
      `,
      demoButton: css`
        /* background: linear-gradient(234.66deg, #4054d1 -1.18%, #17ceca 112.11%); */
        ${responsive.create({
          width: {
            default: '100%',
          },
        })}
      `,

      visionTitle: css`
        color: var(--text-color);
        margin-bottom: ${theme.spacing.get(16)};
        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.lg}`,
            md: `${theme.fonts.size.xl}`,
            lg: `${theme.fonts.size['3xl']}`,
          },
        })}
      `,

      visionDescription: css`
        color: var(--desc-text-color);
        font-size: ${theme.fonts.size.xl};
        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.sm}`,
            md: `${theme.fonts.size.sm}`,
            lg: `${theme.fonts.size.xl}`,
          },
        })}
        max-width: 518px;
      `,

      quotes: css`
        /* margin-top: ${theme.spacing.get(144)}; */
        margin-left: ${theme.spacing.get(24)};

        color: var(--desc-text-color);
        font-style: italic;
        max-width: 567px;

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.xxl}`,
            md: `${theme.fonts.size.xl}`,
            lg: `${theme.fonts.size['3xl']}`,
          },
          marginTop: {
            default: `${theme.spacing.get(80)}`,
            md: `${theme.spacing.get(100)}`,
            lg: `${theme.spacing.get(144)}`,
          },
        })}
      `,

      /* IMAGE SIDE */
      imageContainer: css`
        flex: 1;
        display: flex;
        justify-content: flex-end;
        padding-right: 0;
        margin-right: -130px; /* pushes image to the edge */
      `,

      buttonfullWidthContainer: css`
        ${responsive.create({
          width: {
            default: '100%',
            md: 'auto',
          },
        })}
      `,
    }),
    [theme],
  );
};
